function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Logo"
}, /*#__PURE__*/React.createElement("rect", {
  width: 217,
  height: 285
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  clipPath: "url(#clip-Logo)"
}, /*#__PURE__*/React.createElement("g", {
  id: "blue",
  transform: "translate(-127 -38)"
}, /*#__PURE__*/React.createElement("path", {
  id: "b-1",
  d: "M170.594,175.053l10.554-14.3.533-119.1-9.922-.2Z",
  transform: "translate(-0.664 -0.053)",
  fill: "#0cd8b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "b-2",
  d: "M322.717,41.48h12.218L228.711,163.155,342.111,322.1l-11.429.522L216.751,163.155Z",
  fill: "#0cd8b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "b-3",
  d: "M170.452,322.076h12.015L182.438,206.3,197.9,189.434l-5.159-7.556L170.439,206.3Z",
  fill: "#0cd8b9"
})), /*#__PURE__*/React.createElement("g", {
  id: "red",
  transform: "translate(-127 -38)"
}, /*#__PURE__*/React.createElement("path", {
  id: "r-1",
  d: "M127.686,41.6h9.819l-.936,281.029h-9.229Z",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "r-2",
  d: "M287.621,39.213l-8.563-.749-.388.749L180.516,149.844l-.031,10.922Z",
  fill: "#d0053e"
}), /*#__PURE__*/React.createElement("path", {
  id: "r-3",
  d: "M192.657,195.01l5.244-5.622,91.616,134.431-8.688.528Z",
  fill: "#d0053e"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217,
    height: 285,
    viewBox: "0 0 217 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.a4200149.svg";
export { ForwardRef as ReactComponent };